import React from 'react';

import { ClickAwayListener } from '@material-ui/core';
import styled from 'styled-components';

import usePopupState from '../hooks/usePopupState';
import { onPopupClickAwayWrapper } from './helper';

// export const SimplePopupContext = React.createContext({ open: false });

export default function SimplePopup({ id, anchorEl, setAnchor, children, className, ...props }) {
  const { open, newId } = usePopupState({ id, anchorEl });
  const handleClickAway = onPopupClickAwayWrapper(anchorEl, setAnchor);

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <PopupContainer className={className} {...props}>
        {open && children}
      </PopupContainer>
    </ClickAwayListener>
  );
}

const PopupContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 150px;
  max-width: 250px;
  z-index: 10;
`;
